import React, { useEffect, useRef, useState } from 'react';
import heartLogo from '../../assets/images/png/heartLogo.png'

export const VideoPlayer = ({ user, localCameraEnabled, client, users }) => {
  const ref = useRef();


  useEffect(() => {
    user.videoTrack.play(ref.current);

    // Add a class to the client's video element
    if (user.uid === client.uid) {
      ref.current.classList.add('doctor_frame');
    }
    else {
      ref.current.classList.add('rtx_video_player');
    }
  }, [user]);



  return (
    <>
      <div className='ng_agora_new'>
        {!localCameraEnabled ? (
          <>
            <div className='emptttt_mini_frame'>
              <img src={heartLogo} alt="Logo Heart" />
            </div>
          </>
        ) : null}
        {users?.length === 1 ? (
          <>
            <div className='emptttt'>
              <img src={heartLogo} alt="Logo Heart" />
            </div>
          </>
        ) : null}
        <div ref={ref}></div>
      </div>
    </>
  );
};